export default __webpack_public_path__ + "static/media/csbi.5e3d533a.webp";